"use strict";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const initSlider = document.querySelector(".o-home-about__list");
        if (!initSlider) return;

        new Swiper(".o-home-about__list", {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            autoHeight: false,
            watchOverflow: true,
            navigation: {
                nextEl: ".o-home-about__arrow--next",
                prevEl: ".o-home-about__arrow--prev",
            },
            breakpoints: {
                680: {
                    slidesPerView: 2,
                },
                1280: {
                    spaceBetween: 8,
                    // opção A (mais estável no vertical):
                    direction: "vertical",
                    slidesPerView: "auto",
                },
            },
        });
    });
}
